import { render } from "./View.vue?vue&type=template&id=4cb8b440"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
script.render = render

export default script